
import { Vector3 } from 'three';
import { Vector2 } from 'three';
import WallMaterialMobile from '../../materials/WallMaterialMobile';

import WallMobile from './WallMobile';
import WallsManager from './WallsManager';

export default class WallsManagerMobile extends WallsManager
{
  constructor()
  {
    super();

    this.MaterialKlass = WallMaterialMobile;
  }

  start()
  {
    super.start('wall_mobile');
  }

  __setup_label(wall, lab)
  {
    let text_pivot = wall.type === 'left' ? new Vector2(0, 1) : new Vector2(0, -1);

    let text_position = new Vector3(
      0,
      wall.type === 'left' ? 43 : -2,
      wall.obj.position.z - 1
    );

    super.__setup_label(wall, lab, text_pivot, text_position);
  }

  __init_walls(wall_name, type, walls, amount, distance_from_center)
  {
    super.__init_walls({
      wall_name: wall_name,
      type: type,
      walls: walls,
      amount: amount,
      distance_from_center: distance_from_center,
      distance_between_walls: 15,
      background_names: ['glass', 'glass_background'],
      light_names: ['light_up', 'light_bottom'],
      WallKlass: WallMobile
    });
  }

  __set_wall_position(wall_obj, distance_from_center, z_position)
  {
    wall_obj.position.set(0, distance_from_center, z_position);
  }

  __get_initial_x_or_y(wall_obj)
  {
    return wall_obj.position.y;
  }
}
